var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBloodpressure = function SvgBloodpressure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bloodpressure_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M56.239 22H50.11a1.78 1.78 0 0 0-1.778 1.778v4.172h-1.801a4.125 4.125 0 0 0-4.125 4.124v.854a3.307 3.307 0 0 1-3.294 3.294h-1.446V23.778A1.777 1.777 0 0 0 35.889 22h-7.111A1.78 1.78 0 0 0 27 23.778v28.444A1.78 1.78 0 0 0 28.778 54h7.11a1.777 1.777 0 0 0 1.779-1.778V46.89h4.16a4.15 4.15 0 0 0 4.136-4.148v-2.37a2.963 2.963 0 0 1 5.926 0v4.242c-1.363.427-2.37 2.37-2.37 4.646 0 2.655 1.303 4.741 2.962 4.741s2.963-2.086 2.963-4.74c0-2.371-1.007-4.22-2.37-4.647V40.37a4.148 4.148 0 0 0-8.296 0v2.37a2.964 2.964 0 0 1-2.951 2.952h-4.16v-8.297h1.446a4.49 4.49 0 0 0 4.48-4.467v-.854a2.94 2.94 0 0 1 2.939-2.939h1.801v4.124a1.78 1.78 0 0 0 1.778 1.778h6.128c.877 0 1.576-.913 1.576-2.074v-8.889c0-1.161-.7-2.074-1.576-2.074m-1.98 27.26c0 2.097-.936 3.555-1.778 3.555-.841 0-1.777-1.458-1.777-3.556s.936-3.555 1.777-3.555c.842 0 1.778 1.457 1.778 3.555m-26.074 2.962v-1.778h1.778a.593.593 0 1 0 0-1.185h-1.778v-4.74h1.778a.593.593 0 1 0 0-1.186h-1.778v-4.74h1.778a.593.593 0 1 0 0-1.186h-1.778v-4.74h1.778a.593.593 0 1 0 0-1.186h-1.778v-4.74h1.778a.593.593 0 0 0 0-1.185h-1.778v-1.778c0-.327.266-.593.593-.593h2.963v29.63h-2.963a.593.593 0 0 1-.593-.593m8.296 0a.593.593 0 0 1-.592.593h-2.963v-29.63h2.963a.593.593 0 0 1 .592.593zM49.518 33.26v-9.481c0-.327.266-.593.593-.593h1.185a1.78 1.78 0 0 1 1.778 1.778v7.111a1.78 1.78 0 0 1-1.778 1.778h-1.185a.593.593 0 0 1-.593-.593m7.111-.296c0 .58-.284.889-.39.889h-2.584a3 3 0 0 0 .604-1.778v-7.111a3 3 0 0 0-.604-1.778h2.583c.107 0 .391.309.391.89zm-5.333-.889a.593.593 0 0 1-.592-.592v-5.926a.593.593 0 0 1 1.185 0v5.926a.593.593 0 0 1-.593.592"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bloodpressure_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5575_46931"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5575_46931",
    result: "shape"
  })))));
};
export default SvgBloodpressure;